// @flow
import * as Sentry from '@sentry/browser';

export default function configureSentryScope(userName: string): void {
  Sentry.configureScope(scope => scope.setUser({ id: userName }));
}
